import React from 'react';

const EditContractForm = ({ formData, handleChange }) => {
  const inputClass = "w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500";

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Contract Number
        </label>
        <input
          type="text"
          name="Contract Number"
          value={formData["Contract Number"]}
          onChange={handleChange}
          className={inputClass}
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Category
        </label>
        <input
          type="text"
          name="category"
          value={formData.category}
          onChange={handleChange}
          className={inputClass}
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Status
        </label>
        <input
          type="text"
          name="status"
          value={formData.status}
          onChange={handleChange}
          className={inputClass}
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Start Date
        </label>
        <input
          type="date"
          name="startDate"
          value={formData.startDate}
          onChange={handleChange}
          className={inputClass}
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          End Date
        </label>
        <input
          type="date"
          name="endDate"
          value={formData.endDate}
          onChange={handleChange}
          className={inputClass}
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Term
        </label>
        <input
          type="text"
          name="Term"
          value={formData.Term}
          onChange={handleChange}
          className={inputClass}
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Parties
        </label>
        <input
          type="text"
          name="Parties"
          value={formData.Parties}
          onChange={handleChange}
          className={inputClass}
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Section/Department
        </label>
        <input
          type="text"
          name="Section Or Department"
          value={formData["Section Or Department"]}
          onChange={handleChange}
          className={inputClass}
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Renewal
        </label>
        <select
          name="renewal"
          value={formData.renewal.toString()}
          onChange={handleChange}
          className={inputClass}
        >
          <option value="true">Yes</option>
          <option value="false">No</option>
        </select>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Client Name
        </label>
        <input
          type="text"
          name="clientName"
          value={formData.clientName}
          onChange={handleChange}
          className={inputClass}
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Client Address
        </label>
        <input
          type="text"
          name="clientAddress"
          value={formData.clientAddress}
          onChange={handleChange}
          className={inputClass}
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Client Postal Code
        </label>
        <input
          type="text"
          name="clientPostalCode"
          value={formData.clientPostalCode}
          onChange={handleChange}
          className={inputClass}
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Client Location
        </label>
        <input
          type="text"
          name="clientLocation"
          value={formData.clientLocation}
          onChange={handleChange}
          className={inputClass}
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Client Phone
        </label>
        <input
          type="text"
          name="clientPhone"
          value={formData.clientPhone}
          onChange={handleChange}
          className={inputClass}
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Client Email
        </label>
        <input
          type="email"
          name="clientEmail"
          value={formData.clientEmail}
          onChange={handleChange}
          className={inputClass}
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Payment Term
        </label>
        <input
          type="text"
          name="paymentTerm"
          value={formData.paymentTerm}
          onChange={handleChange}
          className={inputClass}
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Contract Amount
        </label>
        <input
          type="text"
          name="contractAmount"
          value={formData.contractAmount}
          onChange={handleChange}
          className={inputClass}
        />
      </div>
      <div className="col-span-full">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Description
        </label>
        <textarea
          name="Contract Description"
          value={formData["Contract Description"]}
          onChange={handleChange}
          className={`${inputClass} h-24`}
        />
      </div>
    </div>
  );
};

export default EditContractForm;